import axios from 'axios';
import swal from 'sweetalert2';
import detect from './Navigateur';

const BASE_URL = process.env.NODE_ENV === 'production' ? window.env.API_URL : process.env.REACT_APP_API_URL;

const instance = axios.create({
    baseURL: BASE_URL,
});

function genererHeader(droit) {
    return droit
        ? {
            headers: {
                Authorization: sessionStorage.getItem('token'),
                Droit: sessionStorage.getItem('droit'),
            },
        }
        : {
            headers: {
                Authorization: sessionStorage.getItem('token'),
            },
        };
}

function catchError(ex) {
    if (!ex.response) {
        swal('Problème de réseau', 'Veuillez vérifier votre connexion Internet.', 'error');
        return;
    }
    console.error(`Erreur ${ex.response.status} : ${ex.message}\n${ex.config.method.toUpperCase()} ${ex.config.url}`);

    switch (ex.response.status) {
    case 400:
        swal(
            'Erreur',
            ex.response && ex.response.data && ex.response.data.Message
                ? ex.response.data.Message
                : "La requête n'a pas pu être comprise pas le serveur.",
            'error',
        );
        break;
    case 401:
        window.location.href = `${window.location.origin}/Deconnexion?expire`;
        break;
    case 403:
        swal('Interdit', 'Vous n\'avez pas la permission', 'error');
        break;
    case 404:
        swal('Non trouvé', "Le chemin demandé n'existe pas sur le serveur.", 'error');
        break;
    case 405:
        swal('Méthode non autorisée', "La méthode spécifiée n'est pas autorisée sur le serveur.", 'error');
        break;
    case 500:
        swal('Erreur interne du serveur', "Une exception s'est produite sur le serveur.", 'error');
        break;
    default:
        swal('Erreur', `L'erreur ${ex.response.status} vient de se produire.`, 'error');
    }
}

function ajouterInfosEE(EE) {
    const env = detect();
    return {
        ...EE,
        Environnement: `Navigateur : ${env.name} ${env.version} / Système d'exploitation : ${env.os}`,
        Site: window.location.host,
    };
}

/* Contrôleur Adherent */

export function obtenirAdherent() {
    return instance
        .get('/api/Adherent', genererHeader(false))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function creerCompte(Form) {
    return instance
        .post('/api/Adherent/Compte/Creer', { ...Form })
        .then(response => response)
        .catch(error => error.response);
}

export function obtenirTokenAutorisation(Email, Password) {
    return instance
        .post('/api/Adherent/Token/Autorisation', {
            Email,
            Password,
        })
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirTokenDroit(numAuto) {
    return instance
        .get(`/api/Adherent/Token/Droit/${numAuto}`, genererHeader(false))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function associerCopropriete(CodeCop, CodePro, MdpPro) {
    return instance
        .post(
            '/api/Adherent/AssocierCopropriete',
            {
                CodeCop,
                CodePro,
                MdpPro,
            },
            genererHeader(false),
        )
        .then(response => response)
        .catch(error => error.response);
}

export function verifierMdp(Actuel) {
    return instance
        .post(
            '/api/Adherent/Motdepasse/Verifier',
            {
                Actuel,
            },
            genererHeader(false),
        )
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function modifierMdp(Actuel, Nouveau) {
    return instance
        .post(
            '/api/Adherent/Motdepasse/Changer',
            {
                Actuel,
                Nouveau,
            },
            genererHeader(false),
        )
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function definirMdp(Email, Id, Actuel, Nouveau) {
    return instance
        .post(
            '/api/Adherent/Motdepasse/definir',
            {
                Email,
                Id,
                Actuel,
                Nouveau,
            },
            genererHeader(false),
        )
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function reinitialiserMdpE1(email) {
    return instance
        .get(`/api/Adherent/Motdepasse/ReinitialiserE1?email=${email}`)
        .then(response => response)
        .catch(error => error.response);
}

export function reinitialiserMdpE3(email, cm, numAutoAdh, Nouveau) {
    return instance
        .post(`/api/Adherent/Motdepasse/ReinitialiserE3?email=${email}&cm=${cm}&num=${numAutoAdh}`, { Nouveau })
        .then(response => response)
        .catch(error => error.response);
}

// Todo : Appeler l'API pour vérifier le code MFA et rediriger vers GMC_URL si le code est correct. Sinon, afficher un message d'erreur.
export function verifierCodeMFA(email, code) {
 //   console.log("verifierCodeMFA")
    return instance
        .post(`/api/Adherent/MFA/VerifierCodeMFA`, { email, code })
        .then(response => response)
        .catch(error => error.response);
}

export function EnvoyerCodeMFA(email) {
   //  console.log("EnvoyerCodeMFA")
    return instance
        .post(`/api/Adherent/MFA/EnvoyerCodeMFA`, { email })
        .then(response => response)
        .catch(error => error.response);
}

/* Contrôleur Copropriete */

export function obtenirCopropriete() {
    return instance
        .get('/api/Copropriete', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirListeProprietaires() {
    return instance
        .get('/api/Copropriete/ProprietairesEtLots', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirBanques() {
    return instance
        .get('/api/Copropriete/Banque', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirChargesCourantes() {
    return instance
        .get('/api/Copropriete/Charges', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirCharges(NumExe) {
    return instance
        .get(`/api/Copropriete/Charges/${NumExe}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirFournisseurs() {
    return instance
        .get('/api/Copropriete/Fournisseurs', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function envoyerReaction(Objet, Memo) {
    return instance
        .post('/api/Adherent/Reaction', { Objet, Memo }, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

export function envoyerQuestion(Objet, Memo) {
    return instance
        .post('/api/Adherent/Question', { Objet, Memo }, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

/* Contrôleur EE */

export function journaliserException(EE) {
    return instance.post('/api/EE/Exception', { ...ajouterInfosEE(EE) }, genererHeader(true));
}

export function journaliserErreur(EE) {
    return instance.post('/api/EE/Erreur', { ...ajouterInfosEE(EE) }, genererHeader(true));
}

export function journaliserMessage(EE) {
    return instance.post('/api/EE/Message', { ...ajouterInfosEE(EE) }, genererHeader(true));
}

export function journaliserConnexion() {
    const env = detect();
    const Navigateur = `${env.name}`;
    let UserAgent =""
    if (typeof navigator !== 'undefined') {
        UserAgent = navigator.userAgent;
    }
    const Os = `${env.os}`;
    return instance.post(`/api/EE/AjoutConnexion`, { Navigateur, Os, UserAgent }, genererHeader(true));
}

/* Contrôleur Fichier */

export function telechargerFichier(token) {
    return `${BASE_URL}/api/Fichier?token=${token}&inline=false`;
}

export function afficherFichier(token) {
    return `${BASE_URL}/api/Fichier?token=${token}&inline=true`;
}

/* Contrôleur Liste */

export function obtenirListePays() {
    return instance
        .get('/api/Liste/Pays', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirListeCivilites() {
    return instance
        .get('/api/Liste/Civilite', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

/* Contrôleur Proprietaire */

export function obtenirProprietaire() {
    return instance
        .get('/api/Proprietaire', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function modifierCoordonnes(ModifCoordOk, LsAdresses, LsContacts) {
    return instance
        .post('/api/Proprietaire/Coordonnees/Modifier', { ModifCoordOk, LsAdresses, LsContacts }, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

export function modifierGestionnaire(LsAdresses, LsContacts) {
    return instance
        .post('/api/Proprietaire/Gestionnaire/Modifier', { LsAdresses, LsContacts }, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

export function supprimerGestionnaire(Gestionnaire) {
    return instance
        .post('/api/Proprietaire/Gestionnaire/Supprimer', { ...Gestionnaire }, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function abonnerEcourrierE1(Informations) {
    return instance
        .post(
            `/api/Proprietaire/Ecourrier/AbonnerE1`,
            {
                ...Informations,
            },
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}

export function abonnerEcourrierE3(token, Data) {
    return instance
        .post(`/api/Proprietaire/Ecourrier/AbonnerE3?token=${token}`, {
            ...Data,
        })
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function abonnerEcourrierE4(token, Data) {
    return instance
        .post(`/api/Proprietaire/Ecourrier/AbonnerE4?token=${token}`, {
            ...Data,
        })
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function desabonnerEcourrier(Consentement) {
    return instance
        .get(`/api/Proprietaire/Ecourrier/Desabonner?consentement=${Consentement}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function desabonnerEcourrierToken(token) {
    return instance
        .get(`/api/Proprietaire/Ecourrier/Desabonner?token=${token}`)
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

/* Inscription eCourrier NG */
export function inscriptionEcourrier(Informations) {
    return instance
        .post(
            `/api/Proprietaire/Ecourrier/Inscription`,
            {
                ...Informations,
            },
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}

export function envoiSMSEcourrier(Tel) {
    return instance
        .post(
            `/api/Proprietaire/Ecourrier/EnvoiSMS`, { Tel },
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}
export function verifTelEcourrier(Code) {
    return instance
        .post(
            `/api/Proprietaire/Ecourrier/VerifTel`, { Code },
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}
export function envoiEmailEcourrier(Email,ModifContacts,Tel) {
    return instance
        .post(
            `/api/Proprietaire/Ecourrier/EnvoiEmail`, { Email, ModifContacts,Tel },
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}

export function CreationConsentementLRE(informations) {
    return instance
        .post(`api/Proprietaire/LRE/Consentement`, {...informations}, genererHeader(true))
        .then(response => response)
        .catch(ex => catchError(ex));
}

export function ModifEtatConsentementLRE(Email) {
    return instance
        .post('api/Proprietaire/LRE/Consentement/ModifEtat', { Email }, genererHeader(true))
        .then(response => response)
        .catch(ex => catchError(ex));
}

export function SupprimerConsentementLRE() {
    return instance
        .get('api/Proprietaire/LRE/Consentement/Supprimer', genererHeader(true))
        .then(response => response)
        .catch(ex => catchError(ex));
}

export function obtenirHistorique() {
    return instance
        .get('/api/Proprietaire/Historique', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirDocuments() {
    return instance
        .get('/api/Proprietaire/Documents', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirDocument(id) {
    return instance
        .get(`/api/Proprietaire/Document/${id}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirDocumentArc(id) {
    
    return instance
        .get(`/api/Proprietaire/DocumentArc/${id}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirMessages() {
    return instance
        .get('/api/Proprietaire/Messages', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirMessage(id) {
    return instance
        .get(`/api/Proprietaire/Message/${id}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirMemoMessage(id) {
    return instance
        .get(`/api/Proprietaire/MemoMessage/${id}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirAffaire(id) {
    return instance
        .get(`/api/Proprietaire/Affaire/${id}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function envoyerMessage(id, contenu) {
    return instance
        .put(`/api/Proprietaire/Message/${id}`, { ...contenu }, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function envoyerMessageNG(id, info) {
    return instance
        .put(`/api/Proprietaire/MessageNG/${id}`, { ...info }, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function envoyerMessageNGHorsPJ(id, info) {
    return instance
        .post(`/api/Proprietaire/MessageNGHorsPJ/${id}`, { ...info }, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function envoyerMessageNGPJ(id, info) {
    return instance
        .post(`/api/Proprietaire/MessageNGPJ/${id}`, { ...info }, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function modifierModePrl(choixModePrl) {
    return instance
        .get(`/api/Proprietaire/Prelevement/ModifMode?choixModePrl=${choixModePrl}`, genererHeader(true))
        .then(response => response)
        .catch(ex => catchError(ex));
}

export function paiementManuel(NomPro, MontantPrl, SoldeAPayer) {
    return instance
        .post('api/Proprietaire/Paiement/PrelevementManuel', { NomPro, MontantPrl, SoldeAPayer }, genererHeader(true))
        .then(response => response)
        .catch(ex => catchError(ex));
}

export function InscriptionPrelevement(SaisieCordBnq) {
    return instance
        .post('api/Proprietaire/Prelevement/IncriptionPrelevement', { ...SaisieCordBnq }, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

export function ProcedureSignatureMandat(Signataire) {
    return instance
        .post('api/Proprietaire/Prelevement/SignatureElectronique', { ...Signataire }, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

export function ObtenirDetailsAvance() {
    return instance
        .get('api/Proprietaire/AvancesDetails', genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}
/* Contrôleur Syndic */

export function obtenirSyndic() {
    return instance
        .get('/api/Syndic', genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirPrestations(bureau) {
    return instance
        .get(`api/Syndic/PrestationsBureau?bureau=${bureau}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirPrestation(prest) {
    return instance
        .get(`api/Syndic/Prestation?prest=${prest}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}


export function obtenirVotantAvecVotes(NumReuSel) {
    return instance
        .get(`api/Proprietaire/VotantEtVotes?NumReunion=${NumReuSel}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function obtenirVotantAvecVotesMAJ(NumReuSel,NumVote,Vote) {
    return instance
        .get(`api/Proprietaire/VotantEtVotesMAJ?NumReunion=${NumReuSel}&NumVote=${NumVote}&Vote=${Vote}`, genererHeader(true))
        .then(response => response.data)
        .catch(ex => catchError(ex));
}

export function validerVotes(NumReunion,NumVotant,NomSignature,LieuSignature) {
    return instance
        .get(`api/Proprietaire/ValiderVotes?NumReunion=${NumReunion}&NumVotant=${NumVotant}&NomSignature=${NomSignature}&LieuSignature=${LieuSignature}`, genererHeader(true))
        .then(response => response)
        .catch(error => error.response);
}

export function verifSiret(siret) {
    return instance
        .post(
            `/api/Proprietaire/VerifSiret`, { siret },
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}

export function enregistreInfoFE(data) {
    console.log(data);
    return instance
        .post(
            `/api/Proprietaire/EnregistreInfoFE`,  data ,
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}

export function enregistreAdresseFE(data) {
    return instance
        .post(
            `/api/Proprietaire/EnregistreAdresseFE`,  data ,
            genererHeader(true),
        )
        .then(response => response)
        .catch(error => error.response);
}


// WEBPACK FOOTER //
// ./src/App_Code/API.js